import { createI18n } from 'vue-i18n'
import it from './locales/it.js'
import en from './locales/en.js'

const LOCALE_KEY = 'poderi_locale'

const savedLocale = localStorage.getItem(LOCALE_KEY) || 'it'

const i18n = createI18n({
  legacy: false,        // Composition API mode
  locale: savedLocale,
  fallbackLocale: 'it',
  messages: { it, en },
  missingWarn: false,
  fallbackWarn: false,
})

/**
 * Cambia la lingua e la persiste in localStorage.
 */
export function setLocale(locale) {
  i18n.global.locale.value = locale
  localStorage.setItem(LOCALE_KEY, locale)
}

/**
 * Re-export di useI18n — compatibile con i vecchi import `from '@/i18n'`.
 * Nei nuovi componenti importare direttamente da 'vue-i18n'.
 */
export { useI18n } from 'vue-i18n'

export default i18n
